import { formatIDR } from "./format";
import { FA_ORDER_STATUS } from "../components/etams/StatusBadge";
// Status label mapping — bahasa Indonesia sesuai TERMS_AND_STATUS.md
// Plus Naming Aliases (CHANGELOG: DB DESIGN_APPROVED → UI "Desain Final Disetujui").

export const DR_STATUS_LABEL = {
  DESIGN_REQUEST_CREATED: "Permintaan Desain Dibuat",
  MENUNGGU_TANDA_JADI: "Belum Bayar Tanda Jadi",
  TANDA_JADI_MENUNGGU_KONFIRMASI: "Tanda Jadi Menunggu Konfirmasi",
  TANDA_JADI_CONFIRMED: "Tanda Jadi Dikonfirmasi",
  DESIGN_IN_PROGRESS: "Desain Sedang Dikerjakan",
  DESIGN_REVISION_REQUESTED: "Desain Minta Revisi",
  DESIGN_APPROVED: "Desain Final Disetujui",
  DRAFT_FA_CREATED: "Draft FA Sudah Dibuat",
  CANCELLED: "Dibatalkan",
};

// FALABEL-01. DITURUNKAN dari `FA_ORDER_STATUS`, tidak ditulis ulang — peta
// itulah satu-satunya sumber, dan sumbernya sendiri adalah CHECK
// `fa_orders_order_status_check` (`004_phase1b_correction_flow.sql:104-117`).
//
// Peta literal yang berdiri di sini sebelumnya sudah menyimpang dari DB dan
// menyamarkannya dengan sempurna: jumlahnya sama-sama 12, tapi hanya 8 yang
// benar-benar cocok. Empat kunci mati (`READY_FOR_QC`, `QC_PASSED`,
// `PELUNASAN_CONFIRMED`, `CLOSED`) ditolak CHECK sehingga mustahil muncul di
// data — tapi tetap terbit sebagai opsi filter di FAList yang dijamin nol
// hasil. Empat nilai sah (`PELUNASAN_WAITING_CONFIRMATION`, `LUNAS`,
// `FREE_OF_CHARGE`, `EXCEPTION_PENDING_OWNER`) nol label, jadi `LUNAS` —
// state paling sering dilihat pada FA yang selesai — tampil sebagai kode
// mentah dan tidak bisa difilter sama sekali.
//
// Bentuk turunan ini menutup kelas galat itu, bukan cuma kejadiannya:
// menambah state baru di DB cukup diikuti SATU kali di `FA_ORDER_STATUS`,
// dan badge + dropdown ikut sendiri. Urutan kunci sengaja diwarisi apa
// adanya — ia urutan daur hidup, dan itu yang dilihat orang di dropdown.
export const FA_STATUS_LABEL = Object.fromEntries(
  Object.entries(FA_ORDER_STATUS).map(([code, v]) => [code, v.l]),
);

export const PAYMENT_TYPE_LABEL = {
  TANDA_JADI: "Tanda Jadi",
  DP: "DP (Down Payment)",
  PELUNASAN: "Pelunasan",
};

// Q68-01 Batch 7. `PAYMENT_STATUS_LABEL` dan `ADJUSTMENT_STATUS_LABEL`
// DIHAPUS dari sini. Keduanya jadi nol-pemakai begitu Batch 3-4 memindahkan
// konsumennya ke `PRStatusBadge` / `AdjustmentStatusBadge`, dan labelnya kini
// hidup di `PR_STATUS_TONE` / `ADJUSTMENT_STATUS_TONE` — satu tempat bersama
// tone-nya, jadi label dan warna tidak bisa lagi berpisah diam-diam.
//
// Membiarkan keduanya berarti menyisakan peta label kembar yang menganggur di
// sebelah peta tone yang hidup: persis bentuk masalah yang melahirkan Q68-01.

// #4b-1 (Q64/Q66): delegasi ke formatter resmi — "Rp" tanpa spasi (A6).
export function rupiah(n) {
  return formatIDR(n);
}

// ============================================================================
// Q68-01 Batch 6 — `TONE_TO_CLASS`, `FA_TONE_SHARED_KEYS`, dan `badgeColor()`
// DIHAPUS DARI SINI. Berkas ini sekarang murni peta LABEL; warna badge tidak
// lagi punya definisi kedua.
//
// Yang dihapus dan kenapa:
//
// 1. `TONE_TO_CLASS` — sepuluh kunci tone dengan NAMA yang sama persis seperti
//    `TONE_CLASSES` di `components/etams/StatusBadge.jsx` tapi isi berbeda di
//    kesepuluhnya. Dua cacat sekaligus: palet keras yang tidak ikut bertukar di
//    mode gelap, DAN varian `-solid` yang isinya identik dengan versi lembutnya
//    sehingga penekanan kuat (mis. "Lunas") tidak pernah benar-benar dirender.
//
// 2. `badgeColor()` — mewarnai lewat TEBAKAN STRING
//    (`status.includes("MENUNGGU")`) atas string telanjang, jadi ia tidak bisa
//    membedakan `CANCELLED` milik FA dari milik Design Request / Special
//    Adjustment / Design Task. Tebakannya juga meleset: `APPROVED` dan
//    `REJECTED` sama-sama jatuh ke fallback biru — dua status berlawanan
//    dengan warna identik di layar.
//
// 3. `FA_TONE_SHARED_KEYS` — tambalan untuk cacat nomor 2, tidak punya alasan
//    hidup sendiri begitu penyebabnya hilang.
//
// Penggantinya BUKAN fungsi baru di sini, melainkan komponen berpeta di
// `components/etams/StatusBadge.jsx` — satu peta tone per kelompok status
// (`FA_ORDER_STATUS`, `DR_STATUS_TONE`, `ADJUSTMENT_STATUS_TONE`,
// `DESIGN_TASK_STATUS_TONE`, `PR_STATUS_TONE`, `EXC_TONE`), sehingga
// kelompok yang berbeda tidak bisa lagi saling mewarnai.
//
// JANGAN menghidupkan kembali helper warna berbasis string di berkas ini.
// Kalau butuh tone baru, tambahkan di `StatusBadge.jsx` (STANDAR_UI A2).
// ============================================================================
